import React, { useState } from "react";
import AssessmentForm from "./AssessmentForm";
import "./assessmentPage.css"; // Assuming you have a CSS file for styling
import AllAssesments from "./AllAssessments";

const AssessmentPage = () => {
  return (
    <div>
      <AllAssesments />
    </div>
  );
};

export default AssessmentPage;
